import { render, staticRenderFns } from "./exhibits.vue?vue&type=template&id=61f027dd&scoped=true"
import script from "./exhibits.vue?vue&type=script&lang=js"
export * from "./exhibits.vue?vue&type=script&lang=js"
import style0 from "./exhibits.vue?vue&type=style&index=0&id=61f027dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f027dd",
  null
  
)

export default component.exports